import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { completeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        completeSession(data);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (err) {
        toast.error(err.response?.data?.detail || "Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F2E9DB]" data-testid="auth-callback">
      <div className="text-[#141B4D] font-semibold animate-pulse">Signing you in…</div>
    </div>
  );
}
